import { vendorRepository } from '~/api/repository/vendor';

export const VENDOR_QUERY_KEY = {
  all: ['vendor'] as const,

  // 입점사 정보 조회
  detail: (vendorId: number) => ({
    queryKey: ['/api/market-place/v1/vendors/{vendorId}', vendorId] as const,
    queryFn: () => vendorRepository.getVendor(vendorId),
  }),

  // 입점사 전시(쇼케이스/그룹) 조회
  display: (vendorId: number) => ({
    queryKey: [
      '/api/market-place/v1/vendor/{vendorId}/display',
      vendorId,
    ] as const,
    queryFn: () => vendorRepository.getVendorDisplay(vendorId),
  }),
};
